/// <amd-module name="Feed/Connect/Redux/ConnectToFeed/ConnectToFeedContracts" />
import * as React from "react";

import { IVSSPageDataAwareState } from "VSS/Redux/Modules/VSSPageData";

import { IFeedHubViewAwareState } from "Feed/Core/Redux/FeedHub";
import { ITfsPageDataAwareState } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataContracts";

import { ITool, ToolId } from "../../Tool";

export interface IConnectToFeedState {
    tool?: ITool;
    tools: ITool[];
    showGetTools?: boolean;
    dismissedTools: ToolId[];
}

export interface IConnectToFeedOwnState {
    connectToFeed: IConnectToFeedState;
}

export interface IConnectToFeedAwareState
    extends IConnectToFeedOwnState,
        IFeedHubViewAwareState,
        ITfsPageDataAwareState,
        IVSSPageDataAwareState {}
